// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1yYg4","errorLogs":"styles_errorLogs__2ssnZ"};